<div class="container my-2">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-8">
      <p class="text-left">
        <span translate>COOKIE.BAR.NOTICE</span>
        <span translate> COOKIE.BAR.FURTHER</span>
        <a target="_blank" rel="noopener noreferrer" href="https://troodi.de/impressum/#ds" class="ms-1 textlink" translate
          >COOKIE.BAR.LINKTITLE</a
        >
      </p>
    </div>
    <div class="col-12 col-lg-4 mt-3">
      <button class="me-2" mat-stroked-button color="primary" (click)="openSettings()">
        <span translate>COOKIE.BAR.SETTINGS</span>
      </button>
      <button mat-button mat-raised-button color="primary" (click)="acceptAll()">
        <span translate>COOKIE.BAR.ACCEPT_ALL</span>
      </button>
    </div>
  </div>
</div>
